import React, { createContext, useContext } from 'react';
import { useAuth } from './AuthContext';
import { ADMIN_EMAILS, isAdminEmail } from '../../supabase/functions/_shared/admin-emails';

interface AdminContextType {
  isAdmin: boolean;
  adminEmails: readonly string[];
}

const AdminContext = createContext<AdminContextType | undefined>(undefined);

export function AdminProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  
  const isAdmin = isAdminEmail(user?.email);

  return (
    <AdminContext.Provider value={{ isAdmin, adminEmails: ADMIN_EMAILS }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdmin() {
  const context = useContext(AdminContext);
  if (context === undefined) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
}

export { ADMIN_EMAILS, isAdminEmail };
